import PropTypes from "prop-types";
import React from "react";

import Icon from "../interface/Icon";
import onPulseAnimationEnd from "../onPulseAnimationEnd";

const ToolbarViewSelector = props => (
  <div
    id={props.id ? props.id : null}
    className={`toolbarViewSelector ${props.pulse ? "pulse" : ""} ${props.disabled ? "disabled" : ""}`}
    onClick={props.disabled ? null : props.onClick}
    onAnimationEnd={onPulseAnimationEnd}
  >
    {props.icon ? (
      <Icon icon={props.icon} color={props.iconColor ? props.iconColor : "iconMono"} className={props.iconClass} />
    ) : null}
    <span>{props.text}</span>
    <Icon className="downArrow" icon="downArrow" color={"iconMid"} />
  </div>
);

ToolbarViewSelector.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  iconClass: PropTypes.string,
  active: PropTypes.bool,
  navigateBackStyle: PropTypes.bool,
  pulse: PropTypes.bool
};

export default ToolbarViewSelector;
